import React from 'react';
import { Image } from 'wix-rich-content-ui-components';
import { s as styleInject } from './style-inject.es-e7b07dd7.js';
import AvatarIcon from './icons/AvatarIcon.js';

var css_248z = ".glob_fontElementMap,.xGIhz{font-family:var(--ricos-font-family,unset)}.jMEe-{box-sizing:border-box;display:flex;flex-direction:column;gap:8px;max-height:360px;min-height:40px;overflow:hidden;overflow:auto}[dir] .jMEe-{background-color:#fff;border-radius:var(--ricos-settings-whitebox-border-radius,2px);box-shadow:var(--ricos-settings-whitebox-box-shadow,0 4px 8px 0 rgba(0,0,0,.1),0 0 4px 0 rgba(0,0,0,.1));padding:8px 0}.jMEe- *,.jMEe- :after,.jMEe- :before{box-sizing:inherit}.jMEe- input{box-sizing:border-box}.f05Vw{align-items:center;align-self:center;color:var(--ricos-settings-text-color,var(--ricos-text-color,#212121));display:flex;font-family:var(--ricos-settings-text-font-family,Helvetica Neue,Helvetica,Arial);font-size:14px;gap:12px;justify-content:start;min-height:36px;width:220px}[dir] .f05Vw{cursor:pointer}[dir=ltr] .f05Vw{padding-left:12px;padding-right:8px}[dir=rtl] .f05Vw{padding-left:8px;padding-right:12px}.f05Vw span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}[dir] .f05Vw.rJ6yj{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.f05Vw ._6CQEa{height:28px;min-height:28px;min-width:28px;overflow:hidden;width:28px}[dir] .f05Vw ._6CQEa{border-radius:50%}";
var styles = {"fontElementMap":"xGIhz","mention_list":"jMEe-","mention_item":"f05Vw","mention_item_selected":"rJ6yj","avatar":"_6CQEa"};
styleInject(css_248z);

const MentionAvatar = ({ src, alt }) => {
  const containerId = `${src}-${alt}-parent`;
  return /* @__PURE__ */ React.createElement("div", null, src ? /* @__PURE__ */ React.createElement(
    Image,
    {
      containerId,
      containerProps: {
        containerId
      },
      className: styles.avatar,
      displayMode: "fill",
      width: 28,
      height: 28,
      uri: src,
      alt
    }
  ) : /* @__PURE__ */ React.createElement(AvatarIcon, { className: styles.avatar }));
};

export { MentionAvatar as M, styles as s };
//# sourceMappingURL=MentionAvatar-324a3fea.js.map
